import * as yup from 'yup';

export const schema = yup.object().shape({
  firstName: yup.string().required('Required field'),
  lastName: yup.string().required('Required field'),
  email: yup.string().max(64).email('Email format is incorrect.').default(''),
  phoneNumber: yup.string(),
});

export const defaultValues = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
};
